/**
 * TableCard's header bands (`headerLevel="PRIMARY"` / `"SECONDARY"` /
 * `"TERTIARY"`): band + text classes for a table's header cells. Shared so a table that is not a
 * TableCard — the passkeys dialog's — wears the same bands and follows any
 * change to them.
 *
 * Dark primary/secondary return ONE class carrying band + text, tuned as a
 * pair; those classes are the dark header band ladder in assets/global.css, so
 * they apply on every page. Tertiary needed no custom dark class. See TableCard's getHeaderClassPrimary/Secondary for the rationale.
 */
export function getPrimaryHeaderClass(isDark: boolean): string {
  return isDark
    ? 'cynque-dark-header-primary'
    : 'bg-primary-darken-3 text-secondary-lighten-4'
}

export function getSecondaryHeaderClass(isDark: boolean): string {
  return isDark
    ? 'cynque-dark-header-secondary'
    : 'bg-primary-darken-1 text-secondary-lighten-4'
}

export function getTertiaryHeaderClass(isDark: boolean): string {
  return isDark
    ? 'bg-blue-grey-darken-4 text-secondary-lighten-1'
    : 'bg-grey-lighten-2 text-primary-darken-1'
}
